import { CHANNEL_SLUGS, connectorsPath } from './connectors-route';

/**
 * Where a `requiresConnect` suggested-task chip's tap should LAND — the Connectors page, scrolled to
 * the specific connector the task would use, on whichever tab actually holds it (a channel like
 * WhatsApp lives under `channels`, everything else under `tools`).
 *
 * Before this, a `requiresConnect` chip did exactly what a ready chip does: prefill the composer and
 * wait for Send. Sending a prompt for an app that isn't connected yet only pushed the "please connect
 * X" ask one turn later, into the conversation — the chip's own "Connect" marker already told the
 * reader this wasn't ready to run, so the tap should take them to the place that fixes that, not to a
 * text box that's going to bounce. Absent `connector` has nowhere to land, so this is `null` and the
 * caller falls back to the ordinary prefill (which is also the null case's only sane behaviour).
 */
export function connectHrefFor(connector: string): string | null {
  if (!connector) return null;
  const tab = (CHANNEL_SLUGS as readonly string[]).includes(connector) ? 'channels' : 'tools';
  return connectorsPath({ tab, target: connector });
}
